import {
  ConfirmationFormSchema,
  PaymentFormField,
} from '@cashier/cashier-model';

import { GeneralFieldCollector } from './fieldCollector';

export const FormSchemaFactory = {
  create: (fields: PaymentFormField[]): ConfirmationFormSchema => {
    const formSchema: ConfirmationFormSchema = {
      commonFieldMap: null,
      fileUploadField: null,
      informationFieldMap: null,
    };

    fields.forEach((field) => {
      GeneralFieldCollector.collect(formSchema, field);
    });

    return formSchema;
  },
};
